import axios from "axios";

export default async function getLicences() {
    const res = await axios.get(`/admin-dashboard/customer-licence-details`)
    return res;
}